export default class GameHistory {
    constructor(api) {
        this.api = api;
        this.GameHistoryClass = null;
    }

    async init(instance) {
        if (!this.GameHistoryClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.gameHistory &&
                this.api.settings.widgetsUrl.gameHistory.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.gameHistory.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.gameHistory &&
                this.api.settings.widgetsUrl.gameHistory.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.gameHistory.css]);
            }
        }

        this.GameHistoryClass = new window.Widget_gameHistory.default(this.api, instance.instance, instance.data && instance.data.settings ? instance.data.settings : {});
    }
}
